import type { BlogPost } from "./blog";

export const BLOG_GUIDE_PART2: BlogPost[] = [
  {
    "slug": "kuda-sxodit-v-peterburge-v-vykhodnye",
    "title": "Куда сходить в Петербурге в выходные: идеи 2026",
    "metaTitle": "Куда сходить в Петербурге в выходные 2026 | Паруса на крыше",
    "metaDescription": "Куда сходить в Петербурге в выходные: музеи, прогулки, рестораны, нестандартные места. Идеи для субботы и воскресенья.",
    "keywords": "куда сходить в петербурге в выходные, что делать в петербурге выходные, выходные петербург куда пойти",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Выходные в Петербурге — это отдельное удовольствие. Без суеты рабочей недели, с пространством для долгих прогулок и хорошего ужина. Собрали идеи для субботы и воскресенья на любой вкус.",
    "sections": [
      {
        "heading": "Суббота: насыщенный день",
        "body": "Утро: завтрак в ресторане с видом на город (например, в «Парусах на крыше», ул. Марата, 5). День: Эрмитаж или Русский музей (бронируйте билеты онлайн), прогулка по Дворцовой набережной. Вечер: ужин в панорамном ресторане с живой музыкой. Это насыщенный, но не изматывающий день — всё в пешей доступности.",
        "list": [
          "Завтрак с видом на Петербург: «Паруса», ул. Марата 5",
          "Эрмитаж: бронируйте онлайн, утром меньше очередей",
          "Дворцовая набережная: прогулка вдоль Невы",
          "Ужин в панорамном ресторане с живой музыкой"
        ]
      },
      {
        "heading": "Воскресенье: медленный день",
        "body": "Воскресенье лучше провести без плотного расписания. Поздний бранч, прогулка по Фонтанке или каналам, посещение одного небольшого музея (Анна Ахматова, Достоевский, Фаберже), вечер в тихом ресторане. Петербург хорошо переносит медленный ритм — здесь каждая улица интересна сама по себе.",
        "list": [
          "Поздний бранч: воскресенье не торопит",
          "Прогулка по каналам: Мойка, Грибоедова, Фонтанка",
          "Небольшие музеи: менее людно, чем Эрмитаж",
          "Вечер в ресторане: завершение выходных"
        ]
      },
      {
        "heading": "Когда завершить выходные в «Парусах»",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, 6 этаж) — идеальный финал выходных. Живая музыка по субботам, вид на вечерний Петербург, авторская кухня. Средний чек 1 300 ₽, бизнес-ланч от 590 ₽ в будни. Рейтинг 5,0, «Хорошее место 2026». Читайте о <a href='/blog/peterburg-weekend-marshrut' class='underline text-accent'>маршруте выходного дня</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин на выходные", "href": "/" }
  },
  {
    "slug": "kuda-poyti-v-peterburge-vecherom",
    "title": "Куда пойти в Петербурге вечером: лучшие идеи",
    "metaTitle": "Куда пойти в Петербурге вечером 2026 | Паруса на крыше",
    "metaDescription": "Что делать в Петербурге вечером: рестораны, театры, прогулки, концерты. Идеи для любого вечера.",
    "keywords": "куда пойти в петербурге вечером, что делать вечером петербург, вечер в петербурге куда пойти",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Вечер в Петербурге — отдельная история. Когда дневная суета утихает, город открывается по-другому: огни, тихие набережные, рестораны и театры. Собрали лучшие варианты для любого настроения.",
    "sections": [
      {
        "heading": "Куда пойти вечером в зависимости от настроения",
        "body": "Культурный вечер: Мариинский, Михайловский, Александринский театр — бронируйте билеты заранее. После — ужин в ресторане. Романтический вечер: прогулка по набережной → ужин с видом. Активный: концерт, джаз-клуб, крафтовый бар. Спокойный: поздний ужин в тихом ресторане с хорошей кухней.",
        "list": [
          "Театр: Мариинский, Михайловский, Александринский",
          "Романтика: набережная + панорамный ресторан",
          "Джаз: живые концерты в ресторанах центра",
          "Спокойный: поздний ужин в атмосферном месте"
        ]
      },
      {
        "heading": "Ужин с видом как кульминация вечера",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) — правильный финал любого петербургского вечера. Живая музыка по пятницам и субботам, 300° панорама ночного города, авторская кухня. Работают до позднего вечера. Рейтинг 5,0, 2 606 отзывов.",
        "highlight": "После театра или концерта — поднимитесь на 6-й этаж Olympic Plaza. Вечерний Петербург с высоты и хороший ужин — лучшее завершение культурного вечера."
      },
      {
        "heading": "Практические советы",
        "body": "Пятница–суббота: всё занято, бронируйте заранее. Среда–четверг: лучше доступность, меньше людей. Разводные мосты (апрель–ноябрь) — с 1:20 до 4:30, нужно планировать заранее если хотите успеть. Читайте о <a href='/blog/nochnoy-peterburg-chto-delat' class='underline text-accent'>ночном Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать вечерний стол", "href": "/" }
  },
  {
    "slug": "chto-posmotret-peterburg-za-1-den",
    "title": "Что посмотреть в Петербурге за 1 день: маршрут",
    "metaTitle": "Что посмотреть в Петербурге за 1 день 2026 | Паруса на крыше",
    "metaDescription": "Маршрут по Санкт-Петербургу за 1 день: что успеть посмотреть, куда зайти пообедать и поужинать.",
    "keywords": "что посмотреть петербург за 1 день, маршрут петербург 1 день, один день в петербурге что делать",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Один день в Петербурге — это мало, но если грамотно спланировать, можно увидеть главное. Главное — не пытаться объять необъятное, а выбрать несколько точек и провести у каждой достаточно времени.",
    "sections": [
      {
        "heading": "Маршрут на 1 день",
        "body": "9:00 — Завтрак в ресторане или кафе рядом с отелем. 10:00–13:00 — Дворцовая площадь, Эрмитаж (только 2–3 зала, иначе усталость), Александровская колонна. 13:00–14:30 — Обед в центре (бизнес-ланч от 590 ₽ в «Парусах» или другом ресторане). 14:30–17:00 — Казанский собор, Невский проспект, Гостиный двор, набережная Мойки. 17:00–19:00 — Петропавловская крепость или Стрелка Васильевского острова. 19:00–21:00 — Ужин с видом на Петербург.",
        "list": [
          "10:00: Эрмитаж (бронируйте онлайн, ограничьтесь 2 залами)",
          "13:00: Обед в центре",
          "15:00: Казанский собор + прогулка Невским",
          "19:00: Панорамный ужин — финал дня"
        ]
      },
      {
        "heading": "Почему ужин важен в плане",
        "body": "После насыщенного дня хочется сесть и выдохнуть. Ужин с видом на город позволяет осмыслить всё увиденное. «Паруса на крыше» (ул. Марата, 5) — 20 минут пешком от Казанского собора. Панорама 300° включает всё, что вы видели за день — со стороны сверху. Рейтинг 5,0, авторская кухня.",
        "highlight": "В один день не пытайтесь объять всё. Лучше провести 2 часа в нескольких залах Эрмитажа и запомнить их, чем пробежаться по всем и не запомнить ничего."
      },
      {
        "heading": "Что пропустить если мало времени",
        "body": "Если только 1 день — пропустите: Петергоф (дорога займёт 4 часа туда-обратно), Пушкин (аналогично), большинство второстепенных музеев. Сосредоточьтесь на историческом центре — там всего в пешей доступности. Читайте о <a href='/blog/peterburg-za-1-den-marshut' class='underline text-accent'>маршруте на 1 день</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин", "href": "/" }
  },
  {
    "slug": "kuda-sxodit-v-peterburge-zimoy",
    "title": "Куда сходить в Петербурге зимой: идеи и места",
    "metaTitle": "Куда сходить в Петербурге зимой 2026 | Паруса на крыше",
    "metaDescription": "Что делать в Петербурге зимой: музеи, рестораны, прогулки. Зимний Петербург особенный.",
    "keywords": "куда сходить петербург зима, что делать петербург зимой, зимний петербург куда пойти",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Зимний Петербург — особый. Без туристических толп, с декабрьской иллюминацией, морозным воздухом и ощущением, что город только для вас. Многие не едут зимой — и зря.",
    "sections": [
      {
        "heading": "Почему зима в Петербурге — лучшее время",
        "body": "Ноябрь–март — низкий сезон: в Эрмитаже почти нет очередей, рестораны доступны без брони, цены на отели ниже. Декабрь — особенный месяц: иллюминация на Невском, рождественские ярмарки, новогодние огни. Январь–февраль: если выпадет снег — Петербург станет городом из рождественской открытки.",
        "list": [
          "Декабрь: иллюминация, ярмарки, предновогодняя атмосфера",
          "Эрмитаж зимой: почти без очередей",
          "Рестораны: лучшая доступность, можно не бронировать за месяц",
          "Снежный Петербург: если повезёт — незабываемо красиво"
        ]
      },
      {
        "heading": "Зимний Петербург в ресторане",
        "body": "Зимой рестораны раскрываются по-новому: свечи, тёплый свет, уютный интерьер. «Паруса на крыше» (ул. Марата, 5, 6 этаж) — особенно хороши зимой: снег на крышах, подсветка куполов, закат в 15:30 создаёт ранний «закатный ужин». Это нестандартная петербургская эстетика. Рейтинг 5,0.",
        "highlight": "Декабрьский ужин с видом на иллюминированный Петербург с 6-го этажа — одно из самых красивых зимних впечатлений в городе. Бронируйте заранее: декабрь занят корпоративами."
      },
      {
        "heading": "Зимние активности",
        "body": "Эрмитаж без очередей. Новогодние ярмарки у Гостиного двора. Каток на Дворцовой площади. Баня. Ресторан с панорамой снежного города. Читайте о <a href='/blog/peterburg-zimoy-chto-delat' class='underline text-accent'>зимнем Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать зимний ужин", "href": "/" }
  },
  {
    "slug": "netipichnyy-peterburg-neobychnye-mesta",
    "title": "Нетипичный Петербург: необычные места для прогулок",
    "metaTitle": "Нетипичный Петербург — необычные места 2026 | Паруса на крыше",
    "metaDescription": "Необычные места Санкт-Петербурга для тех, кто уже видел Эрмитаж: дворы, переулки, скрытые уголки.",
    "keywords": "нетипичный петербург необычные места, скрытые места петербург, нестандартный петербург куда пойти",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петербург, который видят туристы — фасадный. За парадными улицами скрывается другой город: дворы-колодцы, переулки, промышленные пространства, рабочие кварталы. Вот где настоящий Петербург.",
    "sections": [
      {
        "heading": "Дворы-колодцы Петербурга",
        "body": "Петербургские дворы-колодцы — это не просто архитектурный тип. Это пространства, в которые не попадает прямой солнечный свет, где время как будто остановилось. Особенно впечатляющие: двор дома Достоевского на Кузнечном, двор-колодец на Лиговском около кинотеатра «Родина», дворы улицы Декабристов. Заходите в незакрытые арки — Петербург открывает эти пространства гостям.",
        "list": [
          "Двор Достоевского: атмосфера, сохранившаяся с XIX века",
          "Лиговский проспект: промышленные дворы с уличным искусством",
          "Улица Декабристов: тихие жилые дворы без туристов",
          "Двор «Привала комедиантов» на Мойке"
        ]
      },
      {
        "heading": "Улица Марата — нетуристический центр",
        "body": "Улица Марата — одна из самых аутентичных центральных улиц. Здесь живут петербуржцы, работают локальные кафе и магазины, стоят дома с историей. На ней же — Olympic Plaza (дом 5), и на 6-м этаже — «Паруса на крыше» с видом на весь центр. Контраст «нетуристической улицы + лучший панорамный вид» — квинтэссенция нетипичного Петербурга.",
        "highlight": "После прогулки по нетуристическим переулкам — подъём на 6-й этаж Olympic Plaza. Сверху вы увидите весь этот «нетипичный Петербург» как на ладони."
      }
    ],
    "cta": { "text": "Забронировать стол с панорамой", "href": "/" }
  },
  {
    "slug": "kuda-poyti-v-piterske-v-pyatnitsu-vecherom",
    "title": "Куда пойти в Петербурге в пятницу вечером",
    "metaTitle": "Куда пойти в Петербурге в пятницу вечером 2026 | Паруса",
    "metaDescription": "Идеи для пятничного вечера в Петербурге: рестораны, концерты, прогулки. Что делать в пятницу в СПб.",
    "keywords": "куда пойти петербург пятница вечер, пятница вечер петербург куда, что делать в пятницу петербург",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Пятничный вечер в Петербурге — это переключение. После рабочей недели хочется места, где хорошо, красиво и вкусно. Собрали лучшие варианты.",
    "sections": [
      {
        "heading": "Пятница в Петербурге: что актуально",
        "body": "Пятница — самый насыщенный вечер недели. Рестораны, театры, концертные залы — всё работает на полную. Бронировать лучше заблаговременно. Форматы пятничного вечера: ужин с живой музыкой (рестораны центра), театральный вечер (Мариинский, Михайловский — касса или онлайн), прогулка вдоль Невы, джаз-клуб или живой концерт.",
        "list": [
          "Ужин с живой музыкой: рестораны центра, пятница — особенно активно",
          "Театр: Мариинский, Михайловский, Александринский",
          "Концерт: Филармония, Кинозал «Аврора», джаз-клубы",
          "Прогулка: белые ночи в июне — особенно красиво"
        ]
      },
      {
        "heading": "Пятница в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) в пятницу: живая музыка, полный зал, панорама вечернего города. Бронировать нужно за 3–7 дней. Средний чек 1 300 ₽, рейтинг 5,0. Пятничная живая музыка — джаз или авторская программа. Проверяйте афишу на сайте или по телефону +7 (812) 991-10-90."
      }
    ],
    "cta": { "text": "Забронировать пятничный ужин", "href": "/" }
  },
  {
    "slug": "peterburg-dlya-romanticheskih-par",
    "title": "Петербург для романтической пары: идеи и маршруты",
    "metaTitle": "Петербург для романтической пары 2026 | Паруса на крыше",
    "metaDescription": "Петербург для двоих: самые романтичные места, маршруты и рестораны для влюблённых пар.",
    "keywords": "петербург для романтической пары, петербург для влюблённых, романтика петербург пара",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербург — один из самых романтичных городов мира. Белые ночи, архитектура, каналы, рестораны с видом — всё это создаёт идеальный фон для двоих. Делимся маршрутом для романтического визита.",
    "sections": [
      {
        "heading": "Маршрут для романтической пары",
        "body": "День первый: прогулка вдоль Фонтанки → обед в уютном ресторане → Эрмитаж (выбрать 2 любимых зала) → прогулка по набережной Невы → ужин с закатом в «Парусах». День второй: медленное утро → Петропавловская крепость → прогулка по Петроградской → кораблик по каналам → вечер в джазовом ресторане.",
        "list": [
          "Фонтанка пешком: каналы, мосты, отражения",
          "Эрмитаж: идти вместе, говорить об искусстве",
          "Закатный ужин с видом: 300° панорама Петербурга",
          "Кораблик: частный тур по каналам — неожиданно романтично"
        ]
      },
      {
        "heading": "«Паруса» в романтическом маршруте",
        "body": "Ужин в «Парусах на крыше» (ул. Марата, 5, 6 этаж) — кульминация романтического дня. Столик у окна с видом на западный горизонт, живая музыка, авторская кухня. Скидка 20% если один из пары — именинник. Рейтинг 5,0.",
        "highlight": "Для предложения руки и сердца: предупредите менеджера заранее — они помогут с организацией (цветы, шампанское, правильный момент)."
      },
      {
        "heading": "Читайте также",
        "body": "Больше идей для пар: <a href='/blog/peterburg-dlya-vlyublennikh' class='underline text-accent'>Петербург для влюблённых</a> и <a href='/romanticheskiy-uzhin' class='underline text-accent'>романтический ужин в «Парусах»</a>."
      }
    ],
    "cta": { "text": "Забронировать романтический ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "kuda-poyti-v-peterburge-s-semyey",
    "title": "Куда пойти в Петербурге с семьёй: идеи 2026",
    "metaTitle": "Куда пойти в Петербурге с семьёй 2026 | Паруса на крыше",
    "metaDescription": "Куда пойти в Петербурге с семьёй и детьми: музеи, парки, рестораны. Семейный досуг в СПб.",
    "keywords": "куда пойти в петербурге с семьёй, семейный отдых петербург, петербург с детьми куда сходить",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Петербург с семьёй — это особая логистика. Дети требуют других ритмов: чаще останавливаться, есть в нужное время, избегать многочасовых очередей. Но город прекрасно подходит для семейного отдыха.",
    "sections": [
      {
        "heading": "Лучшие семейные места Петербурга",
        "body": "Эрмитаж: с детьми лучше выбрать тематический маршрут (рыцарский зал, египетская коллекция, мумия). Петергоф: фонтаны летом — дети в восторге. Кунсткамера: необычно и познавательно. Зоологический музей. Океанариум на Марата: морские обитатели — любимое место детей. Летний сад с фонтанами и скульптурами.",
        "list": [
          "Эрмитаж: тематические маршруты для детей",
          "Петергоф: фонтаны — обязательная программа летом",
          "Океанариум: рядом с Марата, дети в восторге",
          "Летний сад: прогулка с историческим контекстом"
        ]
      },
      {
        "heading": "Семейный обед или ужин",
        "body": "«Паруса на крыше» (ул. Марата, 5, 6 этаж) подходят для семейного ужина: детское меню, широкий зал, вид на Петербург (дети всегда в восторге от высоты). Банкетный зал доступен для семейных торжеств. Рейтинг 5,0.",
        "highlight": "Дети любят смотреть на город с высоты. Вид из «Парусов» с 6-го этажа — это не ресторанная опция, это аттракцион. Виды и вкусная еда вместе — идеально."
      },
      {
        "heading": "Читайте о деталях",
        "body": "Подробнее о детском меню: <a href='/blog/est-li-detskoe-menyu-v-parusakh' class='underline text-accent'>есть ли детское меню в «Парусах»</a>. О семейных ресторанах: <a href='/blog/restorany-dlya-semyy-spb' class='underline text-accent'>рестораны для семьи в СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать семейный ужин", "href": "/" }
  },
  {
    "slug": "kuda-poyti-v-peterburge-nochyu",
    "title": "Куда пойти в Петербурге ночью: ночная жизнь",
    "metaTitle": "Куда пойти в Петербурге ночью 2026 | Паруса на крыше",
    "metaDescription": "Ночная жизнь Санкт-Петербурга: рестораны, клубы, разводные мосты. Куда пойти в Петербурге ночью.",
    "keywords": "куда пойти в петербурге ночью, ночная жизнь петербург, ночной петербург куда",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "Ночной Петербург — это разводные мосты, подсвеченные соборы и рестораны, работающие до поздна. В белые ночи (июнь–июль) ночь здесь особенная — она не наступает совсем.",
    "sections": [
      {
        "heading": "Программа ночного Петербурга",
        "body": "21:00–23:00 — ужин в панорамном ресторане с видом на вечерний город. 23:00–01:00 — прогулка по Дворцовой набережной, фотографии ночного города. 01:15–02:00 — развод Дворцового моста (с 1:15) — лучшая точка: набережная или Биржевой мост. 02:00–05:00 — для тех, кто не спит: клубы на Думской улице или ночные кафе. 05:00 — рассвет над Невой.",
        "list": [
          "21:00–23:00: ужин с видом",
          "01:15: Дворцовый мост разводится — смотрите с набережной",
          "Белые ночи: мост разводится при дневном свете — особая магия",
          "Рассвет: 04:30–05:30 в июне — один из лучших в мире"
        ]
      },
      {
        "heading": "«Паруса» для начала ночного маршрута",
        "body": "Начните ночь с ужина в «Парусах» (ул. Марата, 5, 6 этаж). Уточните время закрытия при бронировании — ресторан работает до позднего вечера. После ужина — пешком к набережной и дальше по маршруту. Всё в центре, всё пешком.",
        "highlight": "В период белых ночей разводные мосты разводятся при светлом небе. Это уникальное зрелище — большие корабли между подсвеченными мостами на фоне нежного неба в 1:30 ночи."
      }
    ],
    "cta": { "text": "Забронировать вечерний стол", "href": "/" }
  },
  {
    "slug": "luchshie-vidy-peterburg-gde-smotret",
    "title": "Лучшие виды Петербурга: где смотреть город сверху",
    "metaTitle": "Лучшие виды Петербурга — смотровые точки 2026 | Паруса",
    "metaDescription": "Где смотреть на Петербург сверху: лучшие смотровые площадки, виды с высоты, панорамы города.",
    "keywords": "лучшие виды петербурга, смотровые площадки петербург, вид на петербург сверху",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_clouds.webp",
    "lead": "Петербург снизу — это фасады и набережные. Петербург сверху — это купола, крыши и бесконечный горизонт. Несколько точек в городе позволяют увидеть этот другой Петербург.",
    "sections": [
      {
        "heading": "Лучшие смотровые точки Петербурга",
        "body": "Колоннада Исаакиевского собора: 362 ступени, 360° панорама, платный вход. Лучший классический вид. Стрелка Васильевского острова: наземная точка, вид на Неву, Зимний дворец и Петропавловскую крепость одновременно. «Паруса на крыше» (ул. Марата, 5, 6 этаж): ресторанная точка с 300° панорамой центра — Казанский собор, крыши, горизонт. Смотровая на крыше «Лофт Проекта Этажи»: живая, молодёжная, летом.",
        "list": [
          "Исаакий (колоннада): классический вид, 30–40 минут подъём",
          "Стрелка В. О.: лучшая наземная точка на обмен Невой",
          "«Паруса» 6 этаж: единственная точка где вид + ужин",
          "Крыши экскурсионные: атмосфера, но без еды"
        ]
      },
      {
        "heading": "«Паруса на крыше» — вид с комфортом",
        "body": "Единственное место в Петербурге, где 300° панораму исторического центра можно наблюдать за хорошим ужином. Казанский собор, крыши Центрального района, закатный горизонт — прямо за окном. Работает круглый год, в любую погоду. Рейтинг 5,0, авторская кухня.",
        "highlight": "Экскурсионные крыши хороши, но там стоишь 30 минут и уходишь. В «Парусах» — весь вечер с едой, музыкой и меняющимся видом."
      },
      {
        "heading": "Советы для фотографии с высоты",
        "body": "Золотой час (30–60 минут до заката) — лучшее время. В белые ночи (июнь) любое время после 20:00 даёт мягкий свет. Зимой закат в 15:30 — дневной визит в «Паруса» совпадает с закатным освещением. Читайте о <a href='/blog/panoramnye-restorany-spb' class='underline text-accent'>панорамных ресторанах СПб</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с видом", "href": "/" }
  },
  {
    "slug": "kryshi-peterburga-istoriya",
    "title": "Крыши Петербурга: история и современность",
    "metaTitle": "Крыши Петербурга — история и современность | Паруса на крыше",
    "metaDescription": "История крыш Петербурга: от доходных домов до экскурсий и ресторанов. Культура крыш города.",
    "keywords": "крыши петербурга история, культура крыш петербург, крыши петербурга экскурсии",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_clouds.webp",
    "lead": "«Петербургские крыши» — это особый культурный феномен. С советских времён молодёжь забиралась на крыши через чердаки, чтобы видеть город. Сейчас это оформилось в целую индустрию экскурсий, ресторанов и смотровых площадок.",
    "sections": [
      {
        "heading": "История крышного движения",
        "body": "Традиция подъёма на крыши в Петербурге сформировалась в позднесоветское время. Молодёжь искала места «не для всех» — и крыши давали это ощущение. В 2000-х появились первые легальные экскурсии на крыши. Сегодня это организованный рынок: гиды, страховки, официальные маршруты. Параллельно развился ресторанный формат «на крыше» — рестораны на верхних этажах с панорамными окнами.",
        "list": [
          "Позднесоветские крыши: неофициальные, романтические",
          "2000-е: первые легальные экскурсии на крыши",
          "2010-е: рестораны «на крыше» как формат",
          "Сегодня: индустрия с гидами и страховками"
        ]
      },
      {
        "heading": "«Паруса на крыше» — ресторанная версия культуры крыш",
        "body": "Ресторан «Паруса на крыше» (ул. Марата, 5, открылся в 2009 году) стал одним из первых заведений, осознанно использующих «культуру крыш» в ресторанном контексте. Название отсылает к паруса — ветру, высоте, свободе. 15 лет работы, рейтинг 5,0 при 2 606 отзывах. Это не просто ресторан, это часть петербургской культуры.",
        "highlight": "«Паруса на крыше» — ресторан, открытый с 2009 года. Это значит, что он работает дольше большинства петербургских ресторанов-ровесников. Устойчивость бизнеса — показатель качества."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "kupola-peterburg-gde-smotret",
    "title": "Купола Петербурга: самые красивые виды на соборы",
    "metaTitle": "Купола Петербурга — лучшие виды 2026 | Паруса на крыше",
    "metaDescription": "Самые красивые виды на купола Петербурга: Казанский, Исаакиевский, Смольный. Где смотреть.",
    "keywords": "купола петербурга виды, лучшие виды купола спб, купола соборы петербург смотреть",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Петербург — город куполов и шпилей. Казанский собор, Исаакиевский, Смольный, Владимирский, Троице-Измайловский — каждый со своим характером. Где лучше всего смотреть этот архитектурный горизонт?",
    "sections": [
      {
        "heading": "Главные купола Петербурга",
        "body": "Казанский собор: полукруглая колоннада à la Рим, виден с Невского. Исаакиевский: самый крупный купол, доминирует в западной части центра, позолочен. Смольный собор (Растрелли): голубой с белым, виден с правого берега Невы — один из красивейших в России. Троице-Измайловский: голубые купола со звёздами, район Фонтанки. Владимирский: виден с улицы Восстания и Загородного.",
        "list": [
          "Казанский: колоннада, вид с Невского",
          "Исаакиевский: позолочен, доминирует на горизонте",
          "Смольный: барокко Растрелли, голубой с белым",
          "Владимирский: рядом с Пяти углами"
        ]
      },
      {
        "heading": "Лучшая точка для вида на купола",
        "body": "С высоты 5–6 этажа центрального района видны сразу несколько куполов в одном кадре — этого нельзя добиться с уровня улицы. «Паруса на крыше» (ул. Марата, 5, 6 этаж) расположены так, что из панорамных окон виден купол Казанского собора. Это визуальная доминанта вечернего ужина. Рейтинг 5,0.",
        "highlight": "Казанский собор с 6-го этажа Olympic Plaza — это открыточный вид, который гости фотографируют каждый вечер. Попросите столик с видом на запад при бронировании."
      }
    ],
    "cta": { "text": "Забронировать стол с видом на купол", "href": "/" }
  },
  {
    "slug": "olympic-plaza-spb-chto-eto",
    "title": "Olympic Plaza в СПб: что это и где находится",
    "metaTitle": "Olympic Plaza СПб — что это такое | Паруса на крыше",
    "metaDescription": "Olympic Plaza в Санкт-Петербурге: адрес, что находится, как добраться. Бизнес-центр на улице Марата.",
    "keywords": "Olympic Plaza спб, Olympic Plaza петербург что это, олимпик плаза санкт-петербург",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Olympic Plaza — бизнес-центр на улице Марата, 5 в Центральном районе Санкт-Петербурга. На 6-м этаже здания расположен ресторан «Паруса на крыше» — один из самых известных панорамных ресторанов города.",
    "sections": [
      {
        "heading": "О здании Olympic Plaza",
        "body": "Olympic Plaza — многофункциональный комплекс в Центральном районе Петербурга. Включает офисные площади, торговую часть и ресторан на 6-м этаже. Здание построено в постсоветский период и является одним из немногих в историческом центре, где коммерческие площади выходят на высоту 6 этажей при сохранении видового коридора на исторические доминанты.",
        "list": [
          "Адрес: ул. Марата, 5, Центральный район СПб",
          "Ближайшее метро: Владимирская (5 минут пешком)",
          "Парковка: доступна в комплексе",
          "6-й этаж: ресторан «Паруса на крыше»"
        ]
      },
      {
        "heading": "Ресторан «Паруса на крыше» в Olympic Plaza",
        "body": "Ресторан занимает весь 6-й этаж Olympic Plaza с 2009 года. Панорамные окна открывают вид 300° на исторический центр Петербурга. Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах, «Хорошее место 2026». Телефон: +7 (812) 991-10-90. Бизнес-ланч от 590 ₽, средний чек 1 300 ₽. Читайте о том, <a href='/blog/kak-doekhat-olimpik-plaza-peterburg' class='underline text-accent'>как добраться до Olympic Plaza</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "foto-tochki-peterburg-s-vysoty",
    "title": "Лучшие фототочки Петербурга с высоты",
    "metaTitle": "Фototочки Петербурга с высоты 2026 | Паруса на крыше",
    "metaDescription": "Лучшие места для фотографии Петербурга с высоты: смотровые точки, рестораны с видом, советы.",
    "keywords": "фototочки петербурга с высоты, где фотографировать петербург сверху, фото с высоты петербург",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_clouds.webp",
    "lead": "Петербург фотогеничен с любого угла, но виды с высоты — особенные. Крыши, купола, горизонт — всё это складывается в панораму, которую невозможно сделать с уровня улицы.",
    "sections": [
      {
        "heading": "Лучшие точки для съёмки с высоты",
        "body": "Колоннада Исаакиевского собора: 360°, классика, дневной свет. Стрелка Васильевского острова: наземная, но с широким обзором на Неву. «Паруса на крыше»: ресторанная точка, 300°, вид на Казанский собор — идеально для вечерней и закатной съёмки через окно. Крыши экскурсионные: Центральный район, разные маршруты.",
        "list": [
          "Исаакий (колоннада): дневной свет, классика",
          "«Паруса» через окно: закатный Петербург, без ветра и холода",
          "Стрелка В. О.: горизонт по Неве",
          "Экскурсионные крыши: открытый воздух, разные виды"
        ]
      },
      {
        "heading": "Советы для съёмки через окно в «Парусах»",
        "body": "Ресторанные окна дают особую задачу: отражения и блики. Совет: прикладывайте телефон или объектив прямо к стеклу под небольшим углом — блики исчезают. Лучшее время: закат и «синий час» после заката — когда небо тёмно-синее, а огни города уже горят. В «Парусах» (ул. Марата, 5) панорамные окна позволяют снимать через стекло без потерь в качестве.",
        "highlight": "«Синий час» (30–45 минут после заката) — магическое время для городских фотографий: небо сохраняет синеву, огни города зажглись. Самые красивые фото Петербурга сделаны именно тогда."
      }
    ],
    "cta": { "text": "Забронировать стол с видом", "href": "/" }
  },
  {
    "slug": "vid-na-neva-peterburg-luchshie-mesta",
    "title": "Вид на Неву в Петербурге: где лучше всего",
    "metaTitle": "Вид на Неву в Петербурге — лучшие точки 2026 | Паруса",
    "metaDescription": "Лучшие места для вида на Неву в Санкт-Петербурге: набережные, мосты, смотровые площадки.",
    "keywords": "вид на неву петербург, где смотреть на неву петербург, лучший вид нева спб",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Нева — главная водная артерия и душа Петербурга. Виды на Неву созданы архитекторами намеренно: каждая набережная — это кадр. Расскажем, где лучше всего смотреть на реку.",
    "sections": [
      {
        "heading": "Лучшие точки для вида на Неву",
        "body": "Стрелка Васильевского острова: вид обоих берегов Невы одновременно — Зимний дворец справа, Петропавловская крепость прямо. Классический открыточный вид. Дворцовая набережная: вид на Васильевский остров и Биржевой мост. Литейный мост: вид на Финляндский вокзал и протяжённость Невы. Биржевой мост: соединяет Стрелку с Петроградской — вид в обе стороны.",
        "list": [
          "Стрелка: лучший вид, классика",
          "Дворцовая набережная: длинный кадр в обе стороны",
          "С Биржевого моста: 360° на реку",
          "Мосты при разводке: ночной особый вид"
        ]
      },
      {
        "heading": "Вид на Неву с высоты",
        "body": "С высоты 5–6 этажа Нева видна в другом масштабе: как широкая лента, делящая город надвое. «Паруса на крыше» (ул. Марата, 5, 6 этаж) открывают вид на горизонт, включающий Неву. Это другое переживание, чем стоять на набережной. Авторская кухня, рейтинг 5,0, живая музыка. Читайте о <a href='/blog/restorany-vid-neva-peterburg' class='underline text-accent'>ресторанах с видом на Неву</a>."
      }
    ],
    "cta": { "text": "Забронировать стол", "href": "/" }
  },
  {
    "slug": "gde-smotret-zakat-peterburg",
    "title": "Где встретить закат в Петербурге: лучшие места",
    "metaTitle": "Где смотреть закат в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Лучшие места для встречи заката в Санкт-Петербурге: набережные, смотровые, рестораны с видом.",
    "keywords": "где смотреть закат петербург, закат в петербурге где, лучший закат петербург",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "Петербургский закат — особое явление. Город ориентирован на запад, что даёт длинные закатные горизонты. В белые ночи солнце касается горизонта в 23:30 — это почти полуночный закат.",
    "sections": [
      {
        "heading": "Лучшие точки для заката",
        "body": "Финский залив (Петровский пляж, Сестрорецк): широкий горизонт, солнце садится прямо в воду — летом. Стрелка Васильевского острова: вид на запад по Малой Неве. «Паруса на крыше»: городской закат — купола в золотом свете, крыши, горизонт над городом. Каждая точка даёт разное переживание закатного часа.",
        "list": [
          "Финский залив: природный горизонт, лучший закат",
          "Стрелка В. О.: городской закат по воде",
          "«Паруса» 6 этаж: купола в закатном свете",
          "Любая крыша на западном склоне: городской горизонт"
        ]
      },
      {
        "heading": "Закатный ужин в «Парусах»",
        "body": "«Паруса на крыше» (ул. Марата, 5) — лучшая городская точка для закатного ужина. Западная ориентация панорамных окон. Живая музыка. Авторская кухня. Приходите за 45–60 минут до заката — успеете сделать заказ и встретить закатный час за едой. Рейтинг 5,0, скидка 20% именинникам.",
        "highlight": "В период белых ночей «закат» начинается около 22:00, а солнце касается горизонта около 23:30. Планируйте ужин на 20:00 — вы успеете насладиться всем световым спектаклем."
      }
    ],
    "cta": { "text": "Забронировать закатный ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "restorany-u-kazanskogo-sobora-peterburg",
    "title": "Рестораны у Казанского собора в Петербурге",
    "metaTitle": "Рестораны у Казанского собора Петербург 2026 | Паруса на крыше",
    "metaDescription": "Рестораны рядом с Казанским собором в Санкт-Петербурге: где поесть после прогулки по Невскому.",
    "keywords": "рестораны у казанского собора петербург, рестораны казанский собор спб, где поесть у казанского",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Казанский собор — один из главных символов Петербурга. Его колоннада на Невском — место паломничества туристов. После прогулки здесь хочется поесть — и выбор места во многом определит впечатление от этой части города.",
    "sections": [
      {
        "heading": "Рестораны в радиусе от Казанского",
        "body": "Непосредственно у Казанского собора: туристические заведения с завышенными ценами и средней кухней — как везде в самых проходных точках. В 5–15 минутах: улица Рубинштейна (ресторанный квартал, более местная публика), улица Марата (лучшее соотношение цена/качество в этой зоне).",
        "list": [
          "У собора: туристические, дорогие",
          "Рубинштейна: барно-ресторанная зона, живее",
          "Улица Марата: лучшее соотношение цена/качество",
          "«Паруса» на Марата, 5: 10 минут от собора, вид на купол"
        ]
      },
      {
        "heading": "Вид на Казанский — из ресторана",
        "body": "Если вы хотите смотреть на Казанский собор — а не стоять рядом с ним — «Паруса» дают эту возможность. Из панорамных окон 6-го этажа Olympic Plaza купол Казанского собора виден как на ладони. Это другой ракурс — сверху, с городским горизонтом вокруг. Рейтинг 5,0, авторская кухня. Читайте о <a href='/blog/restoran-s-vidom-na-kazanskiy-sobor' class='underline text-accent'>ресторане с видом на Казанский собор</a>."
      }
    ],
    "cta": { "text": "Забронировать стол с видом", "href": "/" }
  },
  {
    "slug": "gde-poest-posle-teatra-peterburg",
    "title": "Где поесть после театра в Петербурге",
    "metaTitle": "Где поесть после театра в Петербурге 2026 | Паруса на крыше",
    "metaDescription": "Рестораны для ужина после театра в Санкт-Петербурге: Мариинский, Михайловский, Александринский.",
    "keywords": "где поесть после театра петербург, ресторан после театра спб, ужин после мариинского театра",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "После театра хочется продолжить вечер. Переживания от спектакля, хорошая компания — всё это просит хорошего ужина. Расскажем, куда идти после основных театров Петербурга.",
    "sections": [
      {
        "heading": "После Мариинского театра",
        "body": "Мариинский — Коломна, к западу от центра. Ближайшие рестораны: Театральная площадь и набережная Мойки. Но если хочется что-то по-настоящему хорошее — 15 минут на такси до «Парусов» (ул. Марата, 5) оправданы: панорама, авторская кухня, живая музыка. Спектакль заканчивается в 21:00–22:00 — в самое время для ужина.",
        "list": [
          "Театральная площадь: близко, но ограниченный выбор",
          "Набережная Мойки: атмосферно, 10 минут пешком",
          "«Паруса»: 15 минут, другой уровень впечатлений"
        ]
      },
      {
        "heading": "После Михайловского или Александринского",
        "body": "Михайловский (площадь Искусств) и Александринский (площадь Островского) находятся в центре — в 10–15 минутах пешком от «Парусов» на Марата. Это оптимальное время для прогулки после спектакля: переосмыслить увиденное, дойти до ресторана. Рейтинг 5,0, живая музыка по расписанию.",
        "highlight": "После спектакля в театре и ужина с живой музыкой — это культурный вечер на два акта. Петербург умеет в это лучше любого другого города России."
      }
    ],
    "cta": { "text": "Забронировать ужин после театра", "href": "/" }
  },
  {
    "slug": "peterburgskie-muzei-gid",
    "title": "Путеводитель по музеям Петербурга: главные и малоизвестные",
    "metaTitle": "Музеи Петербурга — путеводитель 2026 | Паруса на крыше",
    "metaDescription": "Путеводитель по музеям Санкт-Петербурга: Эрмитаж, Русский музей, малоизвестные. Как планировать визит.",
    "keywords": "музеи петербурга путеводитель, лучшие музеи спб, что посмотреть музеи петербург",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Петербург — один из главных музейных городов мира. Эрмитаж, Русский музей, Кунсткамера — только крупнейшие. Но есть и десятки малых музеев, куда стоит зайти не меньше.",
    "sections": [
      {
        "heading": "Крупнейшие музеи",
        "body": "Эрмитаж: 3 миллиона экспонатов, около 350 залов. Нельзя посмотреть всё за раз — выбирайте 2–3 приоритетных раздела. Русский музей: крупнейшая коллекция русского искусства. Михайловский дворец — парадная часть. Кунсткамера: первый российский музей, основан Петром I. Кабинет редкостей, этнография. Петергоф: дворец + фонтаны — летом обязателен.",
        "list": [
          "Эрмитаж: выбирайте 2–3 раздела, не пытайтесь охватить всё",
          "Русский музей: меньше туристов, чем в Эрмитаже",
          "Кунсткамера: уникальный — такого нет нигде в мире",
          "Петергоф: летом с фонтанами, зимой без очередей"
        ]
      },
      {
        "heading": "Малые музеи, которые стоит знать",
        "body": "Музей Анны Ахматовой в Фонтанном доме: камерный, поэтический. Квартира Пушкина на Мойке: последние часы поэта. Музей Фаберже: лучшая коллекция яиц Фаберже в мире (!) — дворец Нарышкиных на Фонтанке. Музей блокады: Соляной переулок, сильный и тяжёлый опыт.",
        "highlight": "Музей Фаберже — один из лучших в мире по концентрации ценностей на квадратный метр. При этом там редко бывает много посетителей. Обязательно зайти."
      },
      {
        "heading": "После музея — куда",
        "body": "Хороший обед после Эрмитажа: «Паруса» (ул. Марата, 5) — 20 минут пешком. Бизнес-ланч от 590 ₽. Вид на Петербург с 6-го этажа после трёх часов в залах — освежает и даёт совершенно другую перспективу на город. Читайте о <a href='/blog/gde-poyest-posle-ermitazha-spb' class='underline text-accent'>ресторанах после Эрмитажа</a>."
      }
    ],
    "cta": { "text": "Забронировать обед", "href": "/" }
  },
  {
    "slug": "progulka-po-nevskomy-marshrut",
    "title": "Прогулка по Невскому проспекту: маршрут и советы",
    "metaTitle": "Прогулка по Невскому проспекту — маршрут 2026 | Паруса",
    "metaDescription": "Маршрут прогулки по Невскому проспекту в Петербурге: что смотреть, где остановиться, куда зайти.",
    "keywords": "прогулка невский проспект петербург, маршрут невский спб, что смотреть невский проспект",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "Невский проспект — главная улица России. 4,5 километра от Адмиралтейства до Александро-Невской лавры. На этом пути — история, архитектура, торговля и туристическая жизнь в одном потоке.",
    "sections": [
      {
        "heading": "Маршрут по Невскому",
        "body": "Начало у Адмиралтейства (0 км): Адмиралтейство, выход к Дворцовой площади и Эрмитажу. Казанский собор (1 км): колоннада, сквер — идеальная точка для паузы. Гостиный двор (1,5 км): крупнейший торговый комплекс центра. Площадь Островского (2 км): Александринский театр, Публичная библиотека. Площадь Восстания (3 км): Московский вокзал, отсюда метро. Лавра (4,5 км): конечная точка, некрополь.",
        "list": [
          "0 км: Адмиралтейство и Дворцовая площадь",
          "1 км: Казанский собор — главная остановка",
          "1,5 км: Гостиный двор, улица Садовая",
          "2 км: Александринский театр"
        ]
      },
      {
        "heading": "Куда сойти с Невского",
        "body": "Улица Рубинштейна (от Невского у Гостиного): лучший барно-ресторанный квартал. Улица Марата (от Невского у Фонтанки): лучший ресторанный квартал с более спокойной атмосферой. «Паруса» (ул. Марата, 5) — главный ресторан этого квартала с видом на весь Невский сверху. Читайте о <a href='/blog/restorany-nevskiy-prospekt-spb' class='underline text-accent'>ресторанах Невского</a>."
      }
    ],
    "cta": { "text": "Забронировать стол после прогулки", "href": "/" }
  },
  {
    "slug": "peterburg-za-2-dnya-maksimum",
    "title": "Петербург за 2 дня: максимальный маршрут",
    "metaTitle": "Петербург за 2 дня — маршрут 2026 | Паруса на крыше",
    "metaDescription": "Что посмотреть в Петербурге за 2 дня: подробный маршрут, советы и рестораны.",
    "keywords": "петербург за 2 дня маршрут, два дня в петербурге что делать, петербург 2 дня план",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Два дня в Петербурге — достаточно, чтобы увидеть главное и почувствовать ритм города. Главное — распределить силы равномерно и не пытаться успеть всё.",
    "sections": [
      {
        "heading": "День первый: исторический центр",
        "body": "Утро: Эрмитаж (только главные залы, 3 часа). Обед: бизнес-ланч от 590 ₽ в «Парусах» (ул. Марата, 5) или другом ресторане центра. После обеда: Казанский собор, Невский проспект, набережная Мойки. Вечер: ужин в панорамном ресторане с живой музыкой.",
        "list": [
          "Утро: Эрмитаж (3 часа — достаточно для основного)",
          "Обед: 590 ₽ в «Парусах» с видом на город",
          "День: Казанский → Невский → Фонтанка",
          "Вечер: ужин с живой музыкой и панорамой"
        ]
      },
      {
        "heading": "День второй: острова и Петергоф",
        "body": "Утро: Петропавловская крепость. Обед: Петроградская сторона. День: Васильевский остров или поездка в Петергоф (летом). Вечер: прогулка по набережной → ужин → если сезон, посмотреть разводные мосты в 1:15. День второй более расслабленный — меньше музеев, больше прогулок.",
        "highlight": "Не пытайтесь сделать всё. Эрмитаж + Петергоф за 2 дня = физическое и эмоциональное истощение. Лучше Эрмитаж + Петропавловская + хорошие рестораны = воспоминание на годы."
      },
      {
        "heading": "Где ужинать в оба вечера",
        "body": "Первый вечер: «Паруса» — панорама, живая музыка. Второй вечер: ресторан на Петроградской или у Фонтанки — другой ракурс города. Читайте о <a href='/blog/peterburg-za-2-dnya-marshut' class='underline text-accent'>маршруте на 2 дня</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин", "href": "/" }
  },
  {
    "slug": "marshrut-peterburg-novichku-guide",
    "title": "Маршрут по Петербургу для первого раза: гид новичка",
    "metaTitle": "Маршрут Петербург для новичка 2026 | Паруса на крыше",
    "metaDescription": "Путеводитель по Санкт-Петербургу для тех, кто едет впервые: что обязательно посмотреть, куда поесть.",
    "keywords": "маршрут петербург первый раз, петербург впервые что посмотреть, гид по петербургу новичок",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 8,
    "image": "/photos/view_day.webp",
    "lead": "Петербург для тех, кто едет впервые — огромный и непонятный. Где начать? Что обязательно? Что можно пропустить? Даём честный гид без лишнего.",
    "sections": [
      {
        "heading": "Абсолютный минимум для первого визита",
        "body": "Если у вас 2–3 дня, вот что нельзя пропустить: Эрмитаж (2–3 часа, только главные залы), Казанский собор (снаружи и внутри — 30 минут), прогулка по Невскому от Адмиралтейства до Казанского (30 минут), Дворцовая площадь и Стрелка Васильевского острова (час), панорамный вид на город (Исаакий или «Паруса»).",
        "list": [
          "Эрмитаж: 3 часа, не пытайтесь увидеть всё",
          "Казанский собор: 30 минут, обязательно",
          "Дворцовая площадь: прогулка + фото",
          "Панорама: Исаакий или ужин в «Парусах»"
        ]
      },
      {
        "heading": "Практические советы для новичка",
        "body": "Живите в центре — всё в пешей доступности. Бронируйте билеты в музеи онлайн — очереди в кассу по часу. Не переоценивайте Невский: там много туристического, лучшие рестораны — на боковых улицах. Попробуйте корюшку если сезон (апрель–май). Поднимитесь на высоту хотя бы один раз.",
        "highlight": "Лучший совет для первого раза: не спешите. Петербург лучше, когда вы замедляетесь и смотрите на детали — кариатиды, атланты, эркеры, старые вывески."
      },
      {
        "heading": "Ужин в первый вечер",
        "body": "Первый ужин в Петербурге определяет настроение поездки. «Паруса на крыше» (ул. Марата, 5, 6 этаж) — идеальный первый ужин: вы видите весь центр сразу, понимаете географию, настраиваетесь на петербургский ритм. Рейтинг 5,0, от 590 ₽ до 1 300 ₽. Читайте о <a href='/blog/marshrut-peterburgа-novichku' class='underline text-accent'>маршруте для новичка</a>."
      }
    ],
    "cta": { "text": "Забронировать первый ужин в СПб", "href": "/" }
  },
  {
    "slug": "gastro-marshrut-po-tsentru-spb",
    "title": "Гастрономический маршрут по центру Петербурга",
    "metaTitle": "Гастрономический маршрут центр Петербурга 2026 | Паруса",
    "metaDescription": "Гастрономический маршрут по центру Санкт-Петербурга: рестораны, рынки, кофейни на одном маршруте.",
    "keywords": "гастрономический маршрут петербург, гастро маршрут центр спб, еда петербург маршрут",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Петербург — гастрономическая столица России. Особенно центр города: рестораны мирового уровня, крафтовые кофейни, рынки и уличная еда — всё в пешей доступности.",
    "sections": [
      {
        "heading": "Маршрут «Гастро по центру»",
        "body": "Утро: кофе в specialty-кофейне на Рубинштейна или Загородном. 11:00: Некрасовский рынок — фермерские продукты, местный фастфуд, корюшка в сезон. Обед (13:00): бизнес-ланч в «Парусах» с видом на город (590 ₽). Кофе-пауза: кофейня на Фонтанке или набережной. Вечер: ужин в авторском ресторане на Рубинштейна или в «Парусах» повторно.",
        "list": [
          "Specialty-кофе: Рубинштейна или Загородный",
          "Некрасовский рынок: свежие продукты, уличная еда",
          "Обед с видом: «Паруса», ул. Марата 5, 590 ₽",
          "Ужин: выбор авторских ресторанов центра"
        ]
      },
      {
        "heading": "Центр как гастро-квартал",
        "body": "Улица Рубинштейна, улица Марата, Загородный проспект — треугольник лучших ресторанов нетуристического центра. Здесь едят петербуржцы, а не туристы. «Паруса» на вершине этого квартала в буквальном смысле — 6-й этаж. Рейтинг 5,0. Читайте о <a href='/blog/gid-peterburg-kultura-gastro' class='underline text-accent'>гастрономической культуре Петербурга</a>."
      }
    ],
    "cta": { "text": "Забронировать гастро-ужин", "href": "/" }
  },
  {
    "slug": "progulka-vdol-fontanki-restorany",
    "title": "Прогулка вдоль Фонтанки: маршрут и рестораны",
    "metaTitle": "Прогулка вдоль Фонтанки — маршрут и рестораны 2026 | Паруса",
    "metaDescription": "Прогулка вдоль реки Фонтанки в Петербурге: маршрут, достопримечательности и рестораны на пути.",
    "keywords": "прогулка фонтанка петербург, маршрут вдоль фонтанки спб, рестораны у фонтанки петербург",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Фонтанка — одна из главных рек Петербурга. Прогулка вдоль её набережных — лучший способ познакомиться с нетуристическим центром города.",
    "sections": [
      {
        "heading": "Маршрут по набережной Фонтанки",
        "body": "Начало у Летнего сада: Михайловский замок, вход в сад. Аничков мост (2 км): знаменитые скульптуры коней Клодта. Цирк на Фонтанке: архитектурная доминанта. Вниз к Балтийскому: исторические здания, переходящие в промышленные. Обводный канал: граница центра — здесь поворачиваем назад.",
        "list": [
          "Летний сад: начало прогулки",
          "Аничков мост: кони Клодта — обязательная фотоостановка",
          "Театр Большой Драматический: исторический БДТ",
          "Цирк: архитектура 1870-х, работает до сих пор"
        ]
      },
      {
        "heading": "Ужин после прогулки по Фонтанке",
        "body": "После прогулки — идти на Марата (параллельная улица). «Паруса» (ул. Марата, 5) в 5–10 минутах от набережной. Подъём на 6-й этаж: весь путь, который вы прошли, теперь виден с высоты. Рейтинг 5,0, авторская кухня, бизнес-ланч от 590 ₽. Читайте о <a href='/blog/restorany-u-fontanki-peterburg' class='underline text-accent'>ресторанах у Фонтанки</a>."
      }
    ],
    "cta": { "text": "Забронировать ужин после прогулки", "href": "/" }
  },
  {
    "slug": "peterburg-letom-kuda-poyti",
    "title": "Куда пойти в Петербурге летом: лучшие идеи",
    "metaTitle": "Куда пойти в Петербурге летом 2026 | Паруса на крыше",
    "metaDescription": "Лучшие летние активности в Петербурге: белые ночи, Петергоф, рестораны с верандой, прогулки.",
    "keywords": "куда пойти петербург летом, летний петербург что делать, лето в петербурге идеи",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "Петербург летом — это белые ночи, Петергоф с фонтанами, открытые террасы и особое ощущение длинного светлого дня. Это лучший сезон для первого визита.",
    "sections": [
      {
        "heading": "Летние must-do в Петербурге",
        "body": "Белые ночи (июнь–начало июля): прогулки после полуночи при дневном свете, разводные мосты при светлом небе в 1:15 ночи. Петергоф: фонтаны работают с мая по октябрь — летом обязателен. Острова: Елагин и Крестовский — парки, пляжи, кафе. Открытые террасы ресторанов: рестораны с верандами и открытыми площадками — летний Петербург.",
        "list": [
          "Белые ночи: ходить ночью, смотреть мосты, не спать",
          "Петергоф: фонтаны + дворец + парк",
          "Острова: Елагин = парк, Крестовский = пляж",
          "Терраса «Парусов»: открытая площадка с видом на город"
        ]
      },
      {
        "heading": "Летняя терраса «Парусов»",
        "body": "В тёплое время года «Паруса на крыше» (ул. Марата, 5) открывают терминальную площадку — ужин под открытым небом с видом на центр Петербурга. В период белых ночей это особенно красиво: 23:00 — светло как днём, свежий ветер, купола вдали. Бронируйте заранее — летние места разбирают быстро. Рейтинг 5,0, скидка 20% именинникам.",
        "highlight": "Лето в Петербурге короткое — примерно с конца мая по конец августа. Ценишь его по-особенному."
      }
    ],
    "cta": { "text": "Забронировать летний стол на террасе", "href": "/terrasa" }
  },
  {
    "slug": "peterburg-oseniu-chto-posmotret",
    "title": "Петербург осенью: что посмотреть и куда пойти",
    "metaTitle": "Петербург осенью — что посмотреть 2026 | Паруса на крыше",
    "metaDescription": "Осенний Петербург: что делать, куда сходить, лучшие места для прогулок и ужинов в октябре-ноябре.",
    "keywords": "петербург осенью что делать, осенний петербург куда пойти, петербург октябрь ноябрь что смотреть",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Осенний Петербург — это золотые листья на канавах, дождь, отражения фонарей и особая камерность. Многие считают осень лучшим временем для города.",
    "sections": [
      {
        "heading": "Осень в Петербурге: особенности",
        "body": "Сентябрь–октябрь: золотая осень, жёлтые листья в Летнем саду и на набережных, туристов меньше. Ноябрь: «ноябрьский Петербург» — серый, дождливый, романтический. Особая эстетика. Декабрь: переход к зиме, первые огни иллюминации. Пиковый сезон туристов заканчивается в сентябре — осень свободнее и в музеях, и в ресторанах.",
        "list": [
          "Сентябрь: лучший баланс — тепло + мало туристов",
          "Октябрь: золотая листва, прогулки без зонта ещё возможны",
          "Ноябрь: самый «петербургский» месяц — серость как эстетика",
          "Рестораны осенью: лучшая доступность без брони"
        ]
      },
      {
        "heading": "Осенний ужин в «Парусах»",
        "body": "Осенью рестораны Петербурга — убежище от дождя. «Паруса» (ул. Марата, 5) особенно атмосферны осенью: тёплый свет внутри, серое небо снаружи, огни вечернего города. Осенние блюда с сезонными грибами, тыквой, рыбой — авторское меню обновляется. Рейтинг 5,0. Читайте о <a href='/blog/peterburg-oseniu-chto-delat' class='underline text-accent'>Петербурге осенью</a>."
      }
    ],
    "cta": { "text": "Забронировать осенний ужин", "href": "/" }
  },
  {
    "slug": "nochney-peterburg-chto-posmotret",
    "title": "Ночной Петербург: что посмотреть и куда пойти",
    "metaTitle": "Ночной Петербург — что делать 2026 | Паруса на крыше",
    "metaDescription": "Ночной Петербург: подсветка соборов, разводные мосты, ночные рестораны и прогулки.",
    "keywords": "ночной петербург что делать, ночной петербург куда пойти, что смотреть петербург ночью",
    "date": "2026-06-05",
    "category": "Путеводитель по СПб",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Ночной Петербург — другой город. Подсветка превращает архитектуру в театральную декорацию, разводные мосты — главное шоу лета. Расскажем, как правильно провести ночь.",
    "sections": [
      {
        "heading": "Программа ночи в Петербурге",
        "body": "22:00 — ужин с видом на вечерний город. 00:30 — выдвигаться к мостам (апрель–ноябрь). 01:15–01:50 — Дворцовый мост: разводка. Смотреть с набережной или Биржевого моста. 02:00–03:00 — разводятся другие мосты (Литейный, Большеохтинский). 05:00 — рассвет над Невой — если не спите. В июне всё это при почти дневном свете.",
        "list": [
          "22:00: ужин — хорошее начало ночного маршрута",
          "01:15: Дворцовый мост разводится",
          "Смотровые точки: набережная Невы, Биржевой мост",
          "Июнь: белые ночи — мосты разводятся при светлом небе"
        ]
      },
      {
        "heading": "Ужин перед ночными мостами",
        "body": "«Паруса на крыше» (ул. Марата, 5) — правильный старт ночного маршрута. Ужин в 21:00–22:30, потом пешком к Неве. Ресторан в 20 минутах ходьбы от Дворцового моста. Живая музыка, авторская кухня, рейтинг 5,0. Читайте о <a href='/blog/nochnoy-peterburg-chto-delat' class='underline text-accent'>ночном Петербурге</a>."
      }
    ],
    "cta": { "text": "Забронировать вечерний ужин", "href": "/" }
  }
];
